export enum SidebarNavTheme {
  /**
   * Default styling: an emblem/indicator on the left of the active item, with larger spacing between items.
   */
  EMBLEM_LEFT = 'emblem-left',
  /**
   * Items get a hovered background highlight, with tighter spacing between items.
   */
  HOVER_BG = 'hover-bg',
}
